"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BooleanInput = _interopRequireDefault(require("../../atoms/BooleanInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// BooleanInput is fully tested, so it would be tautological to test this too.

/* istanbul ignore next */
function Checkbox(props, ref) {
  return _react.default.createElement(_BooleanInput.default, _extends({}, props, {
    ref: ref,
    type: "checkbox"
  }));
}

var CheckboxWithRef = (0, _react.forwardRef)(Checkbox);
CheckboxWithRef.propTypes = {
  id: _propTypes.default.string,
  label: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  required: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['normal', 'small']),
  status: _propTypes.default.oneOf(['normal', 'warning']),
  warningMessage: _propTypes.default.string
};
CheckboxWithRef.defaultProps = {
  size: 'normal',
  status: 'normal',
  required: false
};
var _default = CheckboxWithRef;
exports.default = _default;